let domain = 'https://smartep.ru';
let apiDomain = 'https://api.smartep.ru';

export const environment = {
  production: true,
  domain,
  apiDomain,
  apiBase: apiDomain + '/api',
  apiKey: '77a74409442f167c505c9d8789ed6b6f805cd62f0b22a862d43ab7f23b97af60',
  // картинки раздаёт backend из ContentRoot/images по /images — тот же хост, что и API
  imagesPath: apiDomain + '/images',
  websiteName: 'Смартеп',
  websiteNameLong: 'Техно новости - Смартеп',
  siteH1: 'Технопортал Смартеп — новости технологий, компьютеров и гаджетов',
  siteDescription: 'Портал новостей и материалов о компьютерах, телефонах, гаджетах и технологиях',
  videoServer: 'https://smartep.ru/videos/news',
  // Видеофайлы курсов лежат на VPS пользователя (не в репо и не в БД)
  coursesVideoServer: 'https://girlsimages.com/videos/courses',
};
